import React from 'react';
import {useSelector} from 'react-redux';
import {useReducerAsync} from 'use-reducer-async';
import GlobalSubcontractorsContainer from './GlobalSubcontractorsContainer';
import getAsyncActionHandlers from './store/asyncActionHandlers';
import reducer from './store/reducer';

const pageSize = 10;

const initialState = {
  loading: true,
  error: false,
  subcontractors: [],
  totalCount: 0,
  pageSize
};
const store = React.createContext(initialState);
export const useCustomStore = () => React.useContext(store);

function GlobalSubcontractorsStore() {
  const {Provider} = store;
  const params = {
    userId: useSelector(globalState => globalState.user.id),
    pageSize
  };

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    getAsyncActionHandlers(params)
  );

  return (
    <Provider value={{state, dispatch}}>
      <GlobalSubcontractorsContainer/>
    </Provider>
  );
}

export default GlobalSubcontractorsStore;
